// Order = priority rank (earlier = higher). GVHD (team 14): A/B > COC (target) > CT (not a target).
export const TYPE_ORDER = ['A', 'B', 'C', 'D', 'E', 'P', 'COC', 'CT']

export const DIR_REASON = 'Deceased/Inactive/Retired'
export const DIR_SUB_REASONS = ['Deceased', 'Inactive', 'Retired']
export const MOT_REASON = 'Moved Out of Territory'

export function getFinalType(row) {
    return row.TARGET_TYPE || row.CHANGED_TARGET_VALUE || row.CURRENT_TARGET_VALUE
}

/** Returns true when a row has been marked DIR (Deceased/Inactive/Retired). */
export function isDIR(row) {
    return (
        (!row.TARGET_TYPE || row.TARGET_TYPE === 'NT') &&
        (row.REASON === DIR_REASON || DIR_SUB_REASONS.includes(row.REASON))
    )
}

/** Returns true when a row has been marked MOT (Moved Out of Territory). */
export function isMOT(row) {
    return row.REASON === MOT_REASON
}

export function resolvePrevType(row, prevCol, fallbackCol = null) {
    return row[prevCol] || (fallbackCol ? row[fallbackCol] : undefined)
}

export function deriveRowStatus(row, prevCol = 'PREV_TARGET_TYPE', fallbackCol = null) {
    // DIR is always treated as dropped — the HCP is being removed from targeting
    // regardless of whether they had a previous type (existing) or were newly added (prev=NT)
    if (isDIR(row)) return 'dropped'
    const prevType = resolvePrevType(row, prevCol, fallbackCol)
    const finalType = getFinalType(row)
    if (!finalType || finalType === 'NT') return (!prevType || prevType === 'NT') ? 'unchanged' : 'dropped'
    if (!prevType || prevType === 'NT') return 'added'
    if (prevType === finalType) return 'unchanged'
    return TYPE_ORDER.indexOf(finalType) < TYPE_ORDER.indexOf(prevType) ? 'promoted' : 'demoted'
}

// ---------------------------------------------------------------------------
// Priority review flag (GVHD, team 14 only).
// Flags the moves OBDs must review: A/B/COC <-> CT/NT, i.e. target flag Y <-> N
// (a target dropped, or a brand-new target added).
// A/B <-> COC is NOT flagged — it is an ordinary demotion / promotion (see TYPE_ORDER).
// Compared against the exercise's proposed type (CURRENT_TARGET_VALUE) and only when the rep made an
// explicit change. DIR/MOT rows are excluded, matching the guardrail counting rules.
// ---------------------------------------------------------------------------
export const PRIORITY_REVIEW_TEAMS = ['14']
const TARGET_FLAG_Y = ['A', 'B', 'COC']

export function getPriorityReview(row, team) {
    if (!PRIORITY_REVIEW_TEAMS.includes(String(team ?? ''))) return null
    const explicitFinal = row.TARGET_TYPE || row.CHANGED_TARGET_VALUE
    if (!explicitFinal || isDIR(row) || isMOT(row)) return null
    const from = row.CURRENT_TARGET_VALUE || 'NT'
    const to = explicitFinal
    if (from === to) return null

    const fromIsTarget = TARGET_FLAG_Y.includes(from)
    const toIsTarget = TARGET_FLAG_Y.includes(to)
    if (fromIsTarget !== toIsTarget) {
        return toIsTarget
            ? { kind: 'targetAdded', label: 'Priority review: new target added (' + from + ' → ' + to + ')' }
            : { kind: 'targetDropped', label: 'Priority review: target dropped (' + from + ' → ' + to + ')' }
    }
    return null
}
